import { render, staticRenderFns } from "./PatientMeasurementsTableHeading.vue?vue&type=template&id=cbb68ec0&scoped=true&"
import script from "./PatientMeasurementsTableHeading.vue?vue&type=script&lang=js&"
export * from "./PatientMeasurementsTableHeading.vue?vue&type=script&lang=js&"
import style0 from "./PatientMeasurementsTableHeading.vue?vue&type=style&index=0&id=cbb68ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb68ec0",
  null
  
)

export default component.exports